<app-threads-scheduler-settings-form [settings]="settings"></app-threads-scheduler-settings-form>
<div class="dialog-footer">
    <mat-dialog-actions>
        <button mat-flat-button color="primary" style="width: 100%" (click)="save()" [disabled]="isFormInvalid">Save
            Settings</button>
    </mat-dialog-actions>
</div>